<div>
  <div class="container">
    <div class="row mt-2">

      <!-- Search Bar -->
      <div class=" col-md-3 search-bar">
        <img class="col-md-3 icon" src="\assets\svg\search_bar.svg" alt="search" />
        <input type="search" class="search-input col-md-9" placeholder="Search"
          (input)="onSearchInput($event.target.value)" />
      </div>
      <!-- Department Filter -->
      <div class="mat-form-field-capabilities ml-1 col-md-3">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>
            <img src="\assets\svg\filter-icon.svg" />
            <span class="common-heading"> Capabilities</span>
          </mat-label>
          <mat-select [(ngModel)]="depSearch" (selectionChange)="onFilterChangeCap()" multiple>
            <mat-option *ngFor="let capability of this.departments" [value]="capability"
              [matTooltipPosition]="position.value" [matTooltipClass]="position.value"
              [matTooltipDisabled]="!ifOverflow(cap)" matTooltip="{{ capability }}">
              <div class="options" #cap>{{ capability }}</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Title filtre -->
      <div class="mat-form-field-title col-md-3">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>
            <img src="\assets\svg\filter-icon.svg" />
            <span class="common-heading"> Documents</span>
          </mat-label>
          <mat-select [(ngModel)]="idTitleSearch" (selectionChange)="onFilterChangeDoc()" multiple>
            <mat-option *ngFor="let id of this.ids" [value]="id" [matTooltipPosition]="position.value"
              [matTooltipClass]="position.value" [matTooltipDisabled]="!ifOverflow(t)" matTooltip=" {{ id }}">
              <div class="options" #t>{{ getFormattedType(id) }}</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-1">
        <div class="row button-wrapper">
          <!-- Button 1: Mail All Employees -->
          <div class="col-md-6">
            <button class="icon-btn" matTooltip="Mail All Employees" (click)="confirmEmailAllUsers()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
                <path fill="none" stroke="#3B4DFF" stroke-width="32" stroke-linecap="round" stroke-linejoin="round"
                  d="M80 64h352a48 48 0 0 1 48 48v288a48 48 0 0 1-48 48H80a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48z" />
                <path fill="none" stroke="#3B4DFF" stroke-width="32" stroke-linecap="round" stroke-linejoin="round"
                  d="M64 128l76.8 85.6c49.6 55.2 131.2 55.2 180.8 0L448 128" />
              </svg>
            </button>
          </div>

          <!-- Button 2: Export Documents -->
          <div class="col-md-6">
            <button class="icon-btn" matTooltip="Export Documents" (click)="openExportOptions()">
              <img src="assets/svg/download.svg" alt="Export" width="18" height="18" />
            </button>
          </div>
        </div>
      </div>


      <!--Pagination-->
      <div class="padding-top col-md-2">
        <pagination-controls class="pagination-controls" [maxSize]="5" [directionLinks]="true"
          (pageChange)="onPageChange($event)" previousLabel="<" nextLabel=">">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isSpinnerActive" class="container">
  <div class="mt-3 row">
    <div class="table-responsive">
      <div class="row active-deactive mt-3" *ngIf="this.selectedUsersDoc.length > 0">
        <div class="left-div">
          <button class="btn-activate active-color" (click)="sendMailToSelectedUsers()">
            Send Mail
          </button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>

            <th colspan="1.7">
              <div class="table-header-cell-name">
                <input type="checkbox" [checked]="this.isChecked" class="check-box-all" (change)="toggleSelectAll()" />
                <span class="name">Name</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">Employee ID</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">Capability</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">Aadhaar ID</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">Address Proof</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">PAN No.</span>
              </div>
            </th>
            <th colspan="1.7">
              <div class="table-header-cell">
                <span class="name">Voter ID</span>
              </div>
            </th>

            <th colspan="1.6">
              <div class="table-header-cell">
                <span class="name"></span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let doc of filteredDocumentData| paginate : { itemsPerPage: this.pageSize, totalItems: this.totalPages * pageSize, currentPage: page }">
            <td colspan="1.7">
              <div class="row center-align">
                <input type="checkbox" class="check-box" (change)="toggleSelectUserDoc(doc)"
                  [checked]="isSelected(doc)" />


                <div class="data" [matTooltip]="doc.firstName + ' ' + doc.lastName"
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
                  <div *ngIf="doc.userThumbnailImage==''">
                    <img class="noemployee_img" src="assets/icons/default-avatar.jpg" alt="Default Avatar" />
                  </div>
                  <div *ngIf="doc.userThumbnailImage!==''">
                    <img class="employee_img mr-2" [src]="doc.userThumbnailImage" alt="Employee Image" />
                  </div>
                  <label class="name" (click)="navigateToProfile(doc.id)">{{ doc.firstName }} {{ doc.lastName }}</label>
                </div>
              </div>
            </td>
            <td colspan="1.7" class="row center-align">
              <div class="row center-align">
                <label class="id">{{ (doc.employeeId) }}
                </label>
              </div>
            </td>
            <td colspan="1.7">
              <div class="row center-align" [matTooltip]="doc.capability | underScoreToSpace | titlecase"
                [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
                <label class="data name-cap">{{ (doc.capability | underScoreToSpace | titlecase).replace('Api', 'API')}}
                </label>
              </div>
            </td>
            <td colspan="1.7">
              <div class="row center-align">
                <p *ngIf="doc.aadharNo==''" class="mt-0_75"> - </p>
                <div *ngIf="doc.aadharNo!==''" style="width: 122px;">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Aadhaar No.</mat-label>
                    <input matInput readonly [value]="doc.aadharNo" />
                  </mat-form-field>
                </div>

              </div>
            </td>
            <td colspan="1.7">
              <div class="row center-align">
                <p *ngIf="doc.addressId==''" class="mt-0_75"> - </p>
                <div *ngIf="doc.addressId!==''" style="width: 122px;">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Address Document No.</mat-label>
                    <input matInput readonly [value]="doc.addressId" />
                  </mat-form-field>
                </div>
              </div>
            </td>
            <td colspan="1.7">
              <div class="row center-align">
                <p *ngIf="doc.panNo==''" class="mt-0_75"> - </p>
                <div *ngIf="doc.panNo!==''" style="width: 122px;">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PAN No.</mat-label>
                    <input matInput readonly [value]="doc.panNo" />
                  </mat-form-field>
                </div>
              </div>
            </td>
            <td colspan="1.7">
              <div class="row center-align">
                <p *ngIf="doc.voterId==''" class="mt-0_75"> - </p>
                <div *ngIf="doc.voterId!==''" style="width: 122px;">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Voter No.</mat-label>
                    <input matInput readonly [value]="doc.voterId" />
                  </mat-form-field>
                </div>
              </div>
            </td>

            <td colspan="1.7">
              <label class="data center-align mt-2">
                <div *ngIf="doc.voterId && doc.panNo && doc.addressId && doc.aadharNo; else elseToolTip"
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value"
                  matTooltip="All documents are uploaded." (click)="allDocsUploaded(doc.id)"
                  [ngClass]="{'dimmed': (doc.voterId && doc.panNo && doc.addressId && doc.aadharNo)}">
                  <img src="./../../../../assets/images/email.png" width="30px" height="30px" />
                </div>
                <ng-template #elseToolTip>
                  <div [matTooltipPosition]="position.value" [matTooltipClass]="position.value"
                    matTooltip="Mail Employee"
                    (click)="confirmEmailSingleUser(doc.id, doc.firstName + ' ' + doc.lastName)"
                    [ngClass]="{'dimmed': (doc.voterId && doc.panNo && doc.addressId && doc.aadharNo)}">
                    <img src="./../../../../assets/images/email.png" width="30px" height="30px" />
                  </div>
                </ng-template>

              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>
<div *ngIf="isSpinnerActive && documentData.length == 0" class="spinner-div">
  <div class="spinner-border left: 10%" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <label class="loading_label">Loading...</label>
</div>
<div *ngIf="!isSpinnerActive && documentData.length == 0 " class="spinner-div">
  <label class="loading_label">No documents</label>
</div>
